module.exports = __webpack_public_path__ + "media/images/icn-loc-small-white-d8a95af178dafdead77ae952916034b0.png";